import { useToast } from "vue-toast-notification";
const toast = useToast();
export const showToast = (type, text, duration = 5000) => {
    toast.open({
      message: text,
      type: type, // "success", "error", "info", "warning"
      duration: duration,
      position: "top-right",
    });
  };